import { useEffect, useMemo, useState } from 'react';
import { useRoomInfo } from '@livekit/components-react';
import { countdownState, parseMeetingEndsAt } from './meetingCountdown';

/**
 * O estado da contagem regressiva do fim da reunião, para quem está dentro da sala (atendente e convidado): o prazo vem do
 * metadado da sala, que o servidor grava quando a reunião começa (e que muda ao vivo, sem recarregar). Só tica a cada segundo
 * quando há prazo.
 *
 * @returns {ReturnType<typeof countdownState>}
 */
export function useMeetingCountdown() {
    const { metadata } = useRoomInfo();
    const endsAt = useMemo(() => parseMeetingEndsAt(metadata), [metadata]);
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        if (endsAt == null) return undefined;
        setNow(Date.now());
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, [endsAt]);

    return useMemo(() => countdownState(endsAt, now), [endsAt, now]);
}
